import clsx from "clsx"
import { useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  LeftPanel,
  RightPanel,
  SearchInput,
  SecondaryNav,
  Spinner,
  Typography
} from "src/blitz"
import { TranslateComponent } from "src/common/translations"
import {
  getAHUCharacteristics,
  getSelectedAHUProperties,
  getSelectedEquipments,
  setSelectedAHUProperties
} from "src/redux/slicers/reportSlice"
import styles from "../ChillerReport/ChillerPerformanceReport.module.scss"
import AHUPropertiesList from "./AHUPropertiesList"

const AHUProperties = () => {
  const [searchText, setSearchText] = useState("")
  const dispatch = useDispatch()
  const ahuCharacteristics = useSelector(getAHUCharacteristics)
  const selectedProperties = useSelector(getSelectedAHUProperties)
  const selectedEquipment = useSelector(getSelectedEquipments)
  const handleSearch = (value: string) => {
    setSearchText(value)
  }
  const isDXCoolType = useMemo(() => {
    const coolTypeChar = ahuCharacteristics?.data?.find(
      (char: { value: string | null; targetKey: string }) =>
        char?.targetKey === "CoolType"
    )
    return coolTypeChar?.value === "DX"
  }, [ahuCharacteristics])
  const showEmptyMessage =
    !selectedEquipment || Object?.keys(selectedEquipment)?.length === 0

  const handleChangeProperties = (property: string) => {
    if (selectedProperties?.includes(property)) {
      const newProps = selectedProperties?.filter(
        (prop: string) => prop !== property
      )
      dispatch(setSelectedAHUProperties(newProps))
    } else {
      dispatch(setSelectedAHUProperties([...selectedProperties, property]))
    }
  }

  return (
    <div className={clsx("col-sm", styles.reportListWrapper)}>
      <div className={clsx(styles.reportPanel)}>
        <SecondaryNav withBorder>
          <LeftPanel>
            <TranslateComponent>Select Report Section</TranslateComponent>
          </LeftPanel>
          <RightPanel>
            <SearchInput
              onInputChange={handleSearch}
              onInputClear={() => setSearchText("")}
              searchText={searchText}
            />
          </RightPanel>
        </SecondaryNav>
        <div className={styles.panelList}>
          {showEmptyMessage ? (
            <Typography
              tagType="div"
              styleType="p1"
              color="graphite"
              className={styles.emptyMessage}
              fontType="italicFont"
            >
              Select your report options to the left.
            </Typography>
          ) : (
            <div className={styles.panelListInner}>
              <div
                className={clsx(styles.reportListBody, {
                  [styles.reportListBodyLoading]: ahuCharacteristics?.loading
                })}
              >
                {ahuCharacteristics?.loading ? (
                  <Spinner loading={ahuCharacteristics?.loading} />
                ) : (
                  <AHUPropertiesList
                    isDXCoolType={isDXCoolType}
                    selectedProperties={selectedProperties}
                    searchText={searchText}
                    handleChangeProperties={handleChangeProperties}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AHUProperties
